var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.029,
    height: 94.902,
    viewBox: "0 0 95.029 94.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_4747499_github_icon",
    "data-name": "4747499_github_icon",
    d: "M59.659,95.876c33.03-.954,36.281-7.907,36.281-47.38C95.94,4.941,91.98.981,48.426.981S.911,4.941.911,48.5c0,39.576,3.271,46.461,36.539,47.388a1.992,1.992,0,0,0,.4-1.271c0-.99-.04-11.15-.059-14.646-12.025,2.53-14.563-5.619-14.563-5.619-1.968-4.839-4.8-6.129-4.8-6.129-3.924-2.6.3-2.546.3-2.546,4.34.3,6.624,4.32,6.624,4.32,3.857,6.4,10.121,4.553,12.583,3.48a8.843,8.843,0,0,1,2.744-5.6c-9.6-1.057-19.695-4.652-19.695-20.708a15.929,15.929,0,0,1,4.451-11.241c-.447-1.061-1.928-5.322.424-11.087,0,0,3.631-1.128,11.89,4.292a42.273,42.273,0,0,1,21.651,0c8.256-5.421,11.879-4.292,11.879-4.292,2.36,5.765.875,10.026.428,11.087a15.892,15.892,0,0,1,4.447,11.241c0,16.1-10.109,19.639-19.742,20.673,1.552,1.295,2.934,3.853,2.934,7.761,0,3.746-.024,10.37-.04,14.761-.008,2.174-.012,3.8-.012,4.253a2.224,2.224,0,0,0,.376,1.263Z",
    transform: "translate(-0.911 -0.981)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.256671d386bb32fce695b0ab3a727a58.svg";
export { ForwardRef as ReactComponent };